import type { PartnerBillingType, PartnerType } from '@/types/partners';

// Dropdowns and the details grid store the CODE and display a friendly label.
// The code tuples below are the single source of the option values; `satisfies`
// ties them to the payload unions so a drifting code is a compile error.
export const BILLING_TYPE_CODES = ['CLIENT_BILLED', 'PARTNER_BILLED'] as const satisfies readonly PartnerBillingType[];

export const BILLING_TYPE_LABELS: Record<PartnerBillingType, string> = {
  CLIENT_BILLED: 'Client Billed',
  PARTNER_BILLED: 'Partner Billed',
  CLIENT_MANAGED: 'Client Billed',
  PARTNER_MANAGED: 'Partner Billed',
};

export function isPartnerBilledType(value: string | null | undefined): boolean {
  return value === 'PARTNER_BILLED' || value === 'PARTNER_MANAGED';
}

export const PARTNER_TYPE_CODES = [
  'CPA_CAS_FIRM',
  'TECHNOLOGY_PARTNER',
  'ENTERPRISE_MULTI_ENTITY_BUSINESS',
  'ECOMMERCE_PLATFORM',
  'MARKETPLACE',
  'OTHER',
] as const satisfies readonly PartnerType[];

export const PARTNER_TYPE_LABELS: Record<PartnerType, string> = {
  CPA_CAS_FIRM: 'CPA/CAS Firm',
  TECHNOLOGY_PARTNER: 'Technology Partner',
  ENTERPRISE_MULTI_ENTITY_BUSINESS: 'Enterprise/Multi-Entity Business',
  ECOMMERCE_PLATFORM: 'E-Commerce Platform',
  MARKETPLACE: 'Marketplace',
  OTHER: 'Other',
};

export const BILLING_TYPE_ITEMS = BILLING_TYPE_CODES.map(value => ({
  value,
  label: BILLING_TYPE_LABELS[value],
}));
export const PARTNER_TYPE_ITEMS = PARTNER_TYPE_CODES.map(value => ({
  value,
  label: PARTNER_TYPE_LABELS[value],
}));

export const formatPartnerBillingType = (value: PartnerBillingType | null | undefined): string =>
  value == null ? '' : BILLING_TYPE_LABELS[value];

export const formatPartnerType = (value: PartnerType | null | undefined): string =>
  value == null ? '' : PARTNER_TYPE_LABELS[value];
